import { CleanSchema, get } from '../../json-transform';

export const copyEvent = new CleanSchema({
  handler_id: get('handler_id.value'),
});
